import React, { Component } from "react";
import NavigationChange from "../../components/NavigationChange";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import ServiceRecordType from "./ServiceRecordType";



class ServiceContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
 
      value: "2",
      userList : [],
      commonArrays: []
    };
  }


 




  handleChange = (event, newValue) => {
    this.setState({ value: newValue },() => {
   });
  };

  render() {
    const { value } = this.state;
    return (
      <>
        <div className="Heading" >
          <NavigationChange
            Topics={"Services Records"}
            numberofRecord={"10"}
            back={true}
          />
        </div>
        <div className="row" id="titleWithDropdowns">
          <TabContext value={value}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <TabList
              
                onChange={this.handleChange}
                aria-label="lab API tabs example"
              >
                <Tab label="Equipment" value="2" style={{color : "black" , fontFamily : "Inter" , fontWeight : "bolder"}}/>
                <Tab label="Vehicle" value="3" style={{color : "black" , fontFamily : "Inter" , fontWeight : "bolder"}}/>
                <Tab label="Building" value="1" style={{color : "black" , fontFamily : "Inter" , fontWeight : "bolder"}} />
               
              </TabList>

            </Box>
            <TabPanel value="1">       
              <ServiceRecordType 
                Type={this.state.value}            
              />
            </TabPanel>
            <TabPanel value="2">
            <ServiceRecordType
               Type={this.state.value}
              
            />
            </TabPanel>
            <TabPanel value="3">
            <ServiceRecordType
               Type={this.state.value}
  
            />
            </TabPanel>
          </TabContext>
        </div>
      </>
    );
  }




  


}
export default ServiceContainer;
